import script from "./ProductOnCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductOnCart.vue?vue&type=script&setup=true&lang=ts"

import "./ProductOnCart.vue?vue&type=style&index=0&id=f670e94c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f670e94c"]])

export default __exports__